<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import TableLoading from "@/components/ipos/table-loading";
import TableEmpty from "@/components/ipos/table-empty";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import UtilsMixin from "@/mixins/utils";
import DatePicker from "vue2-datepicker";
import {brandService} from "@/services/authservice/brand";
import {promotionService} from "@/services/authservice/promotion";
import { commonService } from "@/services/common";

export default {
  page: {
    title: "Danh sách giảm giá của NPP",
    meta: [{name: "description", content: appConfig.description}],
  },
  mixins: [UtilsMixin],
  components: {Layout, PageHeader, TableLoading, TableEmpty, Multiselect, DatePicker},
  data() {
    return {
      listBrand: [],
      listData: [],
      listPromotion: [],
      listChannel: [],
      listStatus: [
        {id: 'CONFIRMED', name: 'Đã xác nhận'},
        {id: 'PENDING', name: 'Chờ xác nhận'},
        {id: 'CANCELED', name: 'Đã huỷ'},
      ],
      title: "Danh sách giảm giá của NPP",
      items: [
        {
          text: "Trang chủ",
          href: "/",
        },
        {
          text: "Khuyến mãi",
          active: true,
        },
        {
          text: "Giảm giá của NPP",
          active: true,
        },
      ],
      submitted: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 50, 100],
      fields: [
        {key: "index", label: "#"},
        {key: "promotion_name", label: "Tên chương trình"},
        {key: "trademark.trademark_name", label: "Nhãn hàng"},
        {key: "date", label: "Thời gian áp dụng"},
        {key: "created_by", label: "Người tạo"},
        {key: "created_at", label: "Thời gian tạo"},
        {key: "status", label: "Trạng thái"},
        {key: "actions", label: ""}
      ],
      isBusy: false,
      me: {},
      searchData: {
        brand: "",
        date: "",
        status: "",
        channel: "",
      },
    };
  },
  beforeMount() {
    this.me = JSON.parse(localStorage.getItem("user"));
    this.getInitData();
  },
  computed: {
    rows() {
      return this.listData.length;
    },
  },
  mounted() {
    this.totalRows = this.listData.length;
  },
  methods: {

    async getInitData() {
      this.isBusy = true;
      // get list brand
      const resBrand = await brandService.getList();
      resBrand.data.data ? this.listBrand = resBrand.data.data : this.listBrand = [];
      // get list sale channel
      const resChannel = await commonService.getListSaleChannel();
      this.listChannel = resChannel.data.data ? resChannel.data.data : [];
      // get list data
      await this.getListDiscount();
      this.isBusy = false;
    },

    async getListDiscount(data) {
      const fparam = {...data, promotion_type: "DISTRIBUTOR", results_per_page: 1000};
      const response = await promotionService.getListPromotion(fparam);
      if (response.data.error) {
        this.listData = [];
        this.$notify({
          group: "app",
          type: "error",
          title: "Đã có lỗi xảy ra",
          text: response.data.error.message,
        });
      } else {
        this.listData = response.data.data;
      }
    },

    async onSearch() {
      const param = {
        trademark_uid: this.searchData.brand ? this.searchData.brand.id : "",
        status: this.searchData.status ? this.searchData.status.id : "",
        from_date: (this.searchData.date !== "" && this.searchData.date[0]) ? this.searchData.date[0].setHours(0, 0, 0, 0) : "",
        to_date: (this.searchData.date !== "" && this.searchData.date[1]) ? this.searchData.date[1].setHours(23, 59, 59, 999) : "",
        channel_uid: this.searchData.channel ? this.searchData.channel.id : "",
      }
      this.isBusy = true;
      await this.getListDiscount(param);
      this.isBusy = false;
    },

    async onResetSearch() {
      this.currentPage = 1;
      this.searchData = {
        brand: "",
        date: "",
        status: ""
      }
      this.isBusy = true;
      await this.getListDiscount();
      this.isBusy = false;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!--Search form-->
            <div class="row mb-3">
              <div class="col-12" style="display: contents">
                <div class="form-group mt-0 mb-2 mr-2">
                  <multiselect
                      class="w200"
                      v-model="searchData.brand"
                      :options="listBrand"
                      track-by="id"
                      label="trademark_name"
                      placeholder="Chọn nhãn hàng"
                      noOptions="Danh sách trống"
                      :show-labels="false"
                  ></multiselect>
                </div>
                <div class="form-group mt-0 mb-0 mr-2 min-w-200">
                  <date-picker
                      v-model="searchData.date"
                      :first-day-of-week="1"
                      lang="en"
                      range
                      format="DD/MM/YYYY"
                      placeholder="Chọn khoảng thời gian"
                      :shortcuts="shortcuts"
                  ></date-picker>
                </div>
                <div class="form-group mt-0 mb-0 mr-2">
                  <multiselect
                      class="w200"
                      v-model="searchData.status"
                      :options="listStatus"
                      track-by="id"
                      label="name"
                      placeholder="Chọn trạng thái"
                      noOptions="Danh sách trống"
                      :show-labels="false"
                      :searchable="false"
                  ></multiselect>
                </div>
                <div class="form-group mt-0 mb-0 mr-2">
                    <multiselect
                        id="shipInfo"
                        v-model="searchData.channel"
                        :options="listChannel"
                        track-by="channel_id"
                        label="channel_name"
                        placeholder="Chọn kênh áp dụng"
                        noOptions="Danh sách trống"
                        :show-labels="false"
                        style="width: 200px;"
                        class="mr-2"
                    ></multiselect>
                  </div>
                <div class="mt-0">
                  <button type="button" class="btn btn-primary" @click="onSearch">Lọc</button>
                  <button type="button" class="ml-2 btn btn-secondary" @click="onResetSearch">
                    <i class="bx bx-revision"></i>
                  </button>
                </div>
              </div>
            </div>
            <!-- Datatable -->
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Hiện
                    <b-form-select
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;mục
                  </label>
                </div>
              </div>
              <!-- Add new -->
              <div class="col-sm-12 col-md-6">
                <div class="row mb-2">
                  <div class="col-lg-12">
                    <div class="d-flex justify-content-end">
                      <router-link
                          class="btn btn-label btn-primary"
                          :to="{ name: 'PromotionDistributorCreate' }">
                        <i class="bx bx-plus label-icon"></i> Thêm mới
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End add new -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  :items="listData"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :busy="isBusy"
                  table-class="scroll-table"
                  show-empty
              >
                <template v-slot:table-busy>
                  <TableLoading/>
                </template>
                <template v-slot:empty>
                  <TableEmpty/>
                </template>
                <template v-slot:cell(index)="row">
                  {{ ((currentPage - 1) * perPage) + row.index + 1 }}
                </template>
                <template v-slot:cell(date)="row">
                  {{ formatDate(row.item.from_date) }} - {{ formatDate(row.item.to_date) }}
                </template>
                <template v-slot:cell(created_at)="row">
                  {{ formatDateUnix(row.item.created_at) }}
                </template>
                <template v-slot:cell(status)="row">
                  <span class="badge badge-pill p-2 text-uppercase"
                        :class="renderStatus(row.item.status)[1]">
                    {{ renderStatus(row.item.status)[0] }}
                  </span>
                </template>
                <template v-slot:cell(actions)="row">
                  <router-link
                      class="btn btn-sm btn-outline-primary m-1"
                      :to="{ name: 'PromotionDistributorDetail', params: { id: row.item.id } }">
                    <i v-if="row.item.status === 'PENDING' || row.item.status === 'CONFIRMED'"
                       class="bx bx-edit align-middle font-size-16"></i>
                    <i v-else class="far fa-eye align-middle font-size-15"></i>
                  </router-link>
                  <router-link
                      class="btn btn-sm btn-outline-primary m-1"
                      :to="{ name: 'PromotionDistributorCopy', params: { id: row.item.id } }">
                    <i class="bx bx-copy align-middle font-size-15"></i>
                  </router-link>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="mt-3 float-right">
                  <b-pagination
                      class="mb-0"
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>